import ReactDOM from 'react-dom/client'
import 'react-quill/dist/quill.snow.css'
import App from './App.tsx'
import './index.css'
import axios from 'axios'

// Set global axios baseURL
const getApiUrl = () => {
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }
  if (window.location.hostname.includes('admin-aims.amy.care')) {
    return 'https://stardust-aims.amy.care';
  }
  return 'http://localhost:3005';
};

axios.defaults.baseURL = getApiUrl();

// Global axios interceptor for handling 401 errors
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      // Redirect to login page
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// Prevent double root creation
const rootElement = document.getElementById('root')!;
if (!rootElement.hasAttribute('data-react-root')) {
  rootElement.setAttribute('data-react-root', 'true');
  ReactDOM.createRoot(rootElement).render(
    <App />
  );
}
